import React from "react";
import { Box, MultiSelect, Stack, Typography } from "convertupleads-theme";
import PreviewAndEditor from "../../../../common/PreviewAndEditor";

const DATA = [
  { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },
  { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },
  { value: "purple", label: "Purple", color: "#5243AA" },
  { value: "red", label: "Red", color: "#FF5630", isFixed: true },
  { value: "orange", label: "Orange", color: "#FF8B00" },
  { value: "yellow", label: "Yellow", color: "#FFC400" },
  { value: "green", label: "Green", color: "#36B37E" },
  { value: "forest", label: "Forest", color: "#00875A" },
  { value: "slate", label: "Slate", color: "#253858" },
  { value: "silver", label: "Silver", color: "#666666" },
];

// const CustomMultiSelect = styled(MultiSelect)(
//   ({ theme, minWidth, maxWidth, OptionsMaxHeight = 200 }) => ({
//     "& .custom-react-select__control": {
//       minWidth: minWidth ? minWidth : "250px",
//       maxWidth: maxWidth ? maxWidth : "250px",
//       minHeight: 40,
//       borderRadius: "8px",
//       backgroundColor: theme.palette.grey[50],
//       borderColor: theme.palette.other.inputOutlinedEnabledBorder,
//       "&:hover": {
//         borderColor: theme.palette.other.inputOutlinedHoverBorder,
//       },
//       "&.custom-react-select__control--is-focused": {
//         borderColor: theme.palette.primary.main,
//       },
//     },
//     "&.rounded": {
//       "& .custom-react-select__control": {
//         "& .custom-react-select__multi-value": {
//           borderRadius: "16px",
//           overflow: "hidden",
//         },
//       },
//     },
//     ".custom-react-select__menu-list": {
//       padding: theme.spacing(1),
//       maxHeight: OptionsMaxHeight,
//       ".custom-react-select__option": {
//         fontFamily: theme.typography.fontFamily,
//         ...theme.typography.body1,
//         fontSize: "14px",
//         borderRadius: 6,
//         cursor: "pointer",
//         "&.custom-react-select__option--is-focused": {
//           backgroundColor: alpha(theme.palette.primary.main, 0.08),
//         },
//         "&.custom-react-select__option--is-selected": {
//           color:'initial',
//           backgroundColor: alpha(theme.palette.primary.main, 0.08),
//         },
//       },
//     },
//   }),
// );

const MultiSelectComp = () => {
  return (
    <Stack spacing={2} p={3}>
      <Box>
        <Typography variant={"h6"} color={"text.primary"}>
          React select - Multiple Select
        </Typography>
        <Typography variant={"body2"} color={"text.primary"}>
          Menus are positioned under their emitting elements, unless they are
          close to the bottom of the viewport.
        </Typography>
      </Box>

      <Box sx={{ width: "80%", alignSelf: "center" }}>
        <Box mb={2}>
          <PreviewAndEditor
            title={"Single Select with React Select."}
            language={"js"}
            value={
              "const DATA = [\n" +
              '  { value: "ocean", label: "Ocean", color: "#00B8D9", isFixed: true },\n' +
              '  { value: "blue", label: "Blue", color: "#0052CC", isDisabled: true },\n' +
              '  { value: "purple", label: "Purple", color: "#5243AA" },\n' +
              '  { value: "red", label: "Red", color: "#FF5630", isFixed: true },\n' +
              '  { value: "orange", label: "Orange", color: "#FF8B00" },\n' +
              '  { value: "yellow", label: "Yellow", color: "#FFC400" },\n' +
              '  { value: "green", label: "Green", color: "#36B37E" },\n' +
              '  { value: "forest", label: "Forest", color: "#00875A" },\n' +
              '  { value: "slate", label: "Slate", color: "#253858" },\n' +
              '  { value: "silver", label: "Silver", color: "#666666" },\n' +
              "];\n\n\n" +
              "           <MultiSelect\n" +
              "              defaultValue={[DATA[0]]}\n" +
              '              name="colors"\n' +
              "              options={DATA}\n" +
              "              components={{ IndicatorSeparator: null }}\n" +
              "            />"
            }
          >
            <MultiSelect
              defaultValue={[DATA[0]]}
              name="colors"
              options={DATA}
              components={{ IndicatorSeparator: null }}
            />
          </PreviewAndEditor>
        </Box>
        <Box mb={2}>
          <PreviewAndEditor
            title={"Multiple Select. Just Add to prop - isMulti."}
            language={"js"}
            value={
              "           <MultiSelect\n" +
              "              defaultValue={[DATA[0], DATA[1]]}\n" +
              "              isMulti\n" +
              '              name="colors"\n' +
              "              options={DATA}\n" +
              "              components={{ IndicatorSeparator: null }}\n" +
              "            />"
            }
          >
            <MultiSelect
              defaultValue={[DATA[0], DATA[1]]}
              isMulti
              name="colors"
              options={DATA}
              components={{ IndicatorSeparator: null }}
            />
          </PreviewAndEditor>
        </Box>

        <Box mb={2}>
          <PreviewAndEditor
            title={`Multiple select with rounded options. Add "className="rounded"`}
            language={"js"}
            value={
              "           <MultiSelect\n" +
              "              defaultValue={[DATA[0], DATA[1]]}\n" +
              "              isMulti\n" +
              '              name="colors"\n' +
              "              options={DATA}\n" +
              '              className="rounded"\n' +
              "              components={{ IndicatorSeparator: null }}\n" +
              "            />"
            }
          >
            <MultiSelect
              defaultValue={[DATA[0], DATA[1]]}
              isMulti
              name="colors"
              options={DATA}
              className="rounded"
              components={{ IndicatorSeparator: null }}
            />
          </PreviewAndEditor>
        </Box>
      </Box>
    </Stack>
  );
};

export default MultiSelectComp;
